import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { contx } from '../../App';
import React from 'react';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { NavLink } from 'react-router-dom';


function BasicExample() {
  const { lang, setLang } = React.useContext(contx);

  const [drlang, setdrlang] = React.useState("English");


  const changeLang = () => {

    if (drlang === "English") {
      setLang("ar")
      setdrlang("عربي")
    }
    else {
      setLang("en")
      setdrlang("English")
    }
  }

 const ennav =['Home','About Us','Contact Us','Courses','Our serveses','Support'];
 const arnav =['الرئيسية','عن الشركة','اتصل بنا','الدورات','من نحن','الدعم'];

 const navname = lang === "en" ? ennav : arnav;

  return (
    <Navbar dir={
      lang === "en" ? "ltr" : "rtl"}
     sticky="top" collapseOnSelect style={{
      backgroundColor: '#F1EBE3',


    }} expand="lg">
      <Container>
        <Navbar.Brand href="#home" className={"align-items-center justify-content-center"} >
          <p style={{fontSize: '15px'}}>
            {
              lang === "en" ? "Tatweer Company for Training, Qualification, Project Management, and Financial Technology (FinTech)":"" +
                  "شركة تطوير للتدريب والتأهيل وإدارة المشاريع والتكنولوجيا المالية (فينتك)"
            }
            </p>
          {/*<img src={logo} style={{ width: '100px' }} alt="logo" />*/}
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto " style={{ margin: '0 10px', fontSize: '18px' }}>
            <NavLink style={{textDecoration:'none',color:'#000', }} className={({ isActive }) => isActive ? 'active mx-3' : 'mx-3'} to="/">{navname[0]}</NavLink> 
            <NavLink style={{textDecoration:'none',color:'#000', }} className={({ isActive }) => isActive ? 'active mx-3' : 'mx-3'} to="/about">{navname[1]}</NavLink>
            <NavLink style={{textDecoration:'none',color:'#000', }} className={({ isActive }) => isActive ? 'active mx-3' : 'mx-3'} to="/Courses">{navname[3]}</NavLink>
            <NavLink style={{textDecoration:'none',color:'#000', }} className={({ isActive }) => isActive ? 'active mx-3' : 'mx-3'} to="/Servises">{navname[4]}</NavLink>
            <NavLink style={{textDecoration:'none',color:'#000', }} className={({ isActive }) => isActive ? 'active mx-3' : 'mx-3'} to="/support">{navname[5]}</NavLink>


          </Nav>


          <NavDropdown
            id="nav-dropdown-dark-example"
            title={drlang}
            menuVariant="dark"
          >
            <NavDropdown.Item onClick={changeLang} >English </NavDropdown.Item>
            <NavDropdown.Item onClick={changeLang} > عربي </NavDropdown.Item>
           
          </NavDropdown>

        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default BasicExample;